import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const modalContent = {
    privacy: {
      title: 'Política de Privacidad',
      content: <div className="space-y-4 text-[#2D1B06]/80 leading-relaxed" data-id="element-21">
          <p data-id="element-22">
            <strong data-id="element-23">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES')}
          </p>
          <p data-id="element-24">
            En El Protocolo 21D, valoramos y respetamos su privacidad. Esta
            Política de Privacidad describe cómo recopilamos, utilizamos y
            protegemos su información personal cuando visita nuestro sitio web o
            adquiere nuestros productos.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-25">
            1. Información que recopilamos
          </h3>
          <p data-id="element-26">
            Podemos recopilar información personal que usted nos proporciona
            directamente, como su nombre, dirección de correo electrónico y
            detalles de pago al realizar una compra. También recopilamos datos
            de uso automáticamente a través de cookies para mejorar su
            experiencia.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-27">
            2. Uso de la información
          </h3>
          <p data-id="element-28">
            Utilizamos su información para procesar transacciones, enviarle el
            producto adquirido, proporcionar soporte al cliente y enviarle
            actualizaciones relevantes sobre nuestros servicios.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-29">
            3. Protección de datos
          </h3>
          <p data-id="element-30">
            Implementamos medidas de seguridad estándar de la industria para
            proteger su información personal contra acceso no autorizado,
            alteración o divulgación. Sus datos de pago son procesados a través
            de pasarelas seguras y encriptadas.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-31">
            4. Compartir información
          </h3>
          <p data-id="element-32">
            No vendemos, intercambiamos ni transferimos su información personal
            a terceros, excepto a proveedores de servicios de confianza que nos
            ayudan a operar nuestro sitio web y llevar a cabo nuestro negocio,
            siempre que acepten mantener esta información confidencial.
          </p>
        </div>
    },
    terms: {
      title: 'Términos de Servicio',
      content: <div className="space-y-4 text-[#2D1B06]/80 leading-relaxed" data-id="element-33">
          <p data-id="element-34">
            <strong data-id="element-35">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES')}
          </p>
          <p data-id="element-36">
            Al acceder y utilizar el sitio web de El Protocolo 21D y adquirir
            nuestros productos, usted acepta estar sujeto a los siguientes
            Términos de Servicio.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-37">
            1. Uso del Producto
          </h3>
          <p data-id="element-38">
            El Protocolo 21D es un producto digital de información. Todo el
            contenido proporcionado es solo para fines educativos e
            informativos. No sustituye el consejo, diagnóstico o tratamiento
            médico profesional.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-39">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-40">
            Todo el contenido, incluyendo textos, gráficos, logotipos y
            materiales digitales proporcionados en este sitio, son propiedad
            exclusiva de El Protocolo 21D y están protegidos por las leyes de
            derechos de autor. Queda estrictamente prohibida su reproducción o
            distribución no autorizada.
          </p>
          <h3 className="text-lg font-bold text-[#2D1B06] mt-6" data-id="element-41">
            3. Limitación de Responsabilidad
          </h3>
          <p data-id="element-42">
            El Protocolo 21D no se hace responsable de ningún daño directo,
            indirecto, incidental o consecuente que resulte del uso o la
            incapacidad de usar nuestros productos o servicios. Los resultados
            pueden variar según el individuo.
          </p>
        </div>
    }
  };
  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  return <>
      <footer className="bg-[#2D1B06] text-white/60 py-10 text-center text-sm" data-id="element-43">
        <div className="max-w-4xl mx-auto px-4" data-id="element-44">
          <p data-id="element-45">
            © {new Date().getFullYear()} El Protocolo 21D. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-46">
            Este producto no sustituye el consejo médico profesional.
          </p>

          <div className="mt-6 flex flex-wrap justify-center gap-4 text-xs font-medium" data-id="element-47">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-48">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-49">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-50">
              Términos de Servicio
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-51">
        {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-52">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-53" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl bg-[#FFF9F0] rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" data-id="element-54">
              <div className="flex items-center justify-between p-6 border-b border-[#E8820C]/20 bg-white" data-id="element-55">
                <h2 className="text-xl sm:text-2xl font-bold text-[#2D1B06]" data-id="element-56">
                  {modalContent[activeModal].title}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 text-[#2D1B06]/50 hover:text-[#DC2626] hover:bg-[#DC2626]/10 rounded-full transition-colors" aria-label="Cerrar" data-id="element-57">
                  <X className="w-6 h-6" data-id="element-58" />
                </button>
              </div>

              <div className="p-6 sm:p-8 overflow-y-auto text-left bg-[#FFF9F0]" data-id="element-59">
                {modalContent[activeModal].content}
              </div>

              <div className="p-4 border-t border-[#E8820C]/20 bg-white text-center" data-id="element-60">
                <button onClick={() => setActiveModal(null)} className="px-6 py-2 bg-[#2D1B06] text-white rounded-lg font-medium hover:bg-[#E8820C] transition-colors" data-id="element-61">
                  Entendido
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}